/* import __COLOCATED_TEMPLATE__ from './sq-loading-manager.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
let SqLoadingManager = (_class = class SqLoadingManager extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "root", _descriptor, this);
    this.root = document.querySelector(':root');
    const emberRouteLoadingIndicatorDisplay = getComputedStyle(this.root).getPropertyValue('--ember-route-loading-indictor-display');
    if (!emberRouteLoadingIndicatorDisplay) {
      /*
        The dashboard rails server serves a pre-loader from application.html.erb to improve First Contentful Paint; unfortunately, when combined with ember's loader,
        this confuses the browser APIs when trying to measure Largest Contentful Paint as it's reasonably unexpected that there are multiple loaders.
        We want to hide the ember router loaders to avoid this.
      */
      this.root.style.setProperty('--ember-route-loading-indictor-display', 'none');
    }
  }
  willDestroy(...args) {
    super.willDestroy(...args);
    /*
      This will allow the router loader to display when navigating between routes as well as
      for pages which accidentally rerender the loader
    */
    this.root.style.setProperty('--ember-route-loading-indictor-display', 'block');
    const preloadingLogoContainer = document.querySelector('.preloading-logo-container');

    /*
      Remove the pre-loader served from the dashboard rails server html response defined in application.html.erb
    */
    if (preloadingLogoContainer) {
      preloadingLogoContainer.remove();
      performance.mark('end-dashboard-app-load');
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "root", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _class);
export { SqLoadingManager as default };